import { render, staticRenderFns } from "./CompraCombobox.vue?vue&type=template&id=3c29c7cb&scoped=true"
import script from "./CompraCombobox.vue?vue&type=script&lang=js"
export * from "./CompraCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c29c7cb",
  null
  
)

export default component.exports